"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfiMallAPI = void 0;
const net = require("@ivanlog/net");
const ArticlesService_1 = require("./classes/ArticlesService");
const AuthService_1 = require("./classes/AuthService");
const BusinessService_1 = require("./classes/BusinessService");
const Connector1CService_1 = require("./classes/Connector1CService");
const DeliveryService_1 = require("./classes/DeliveryService");
const DirectoryService_1 = require("./classes/DirectoryService");
const FavoriteService_1 = require("./classes/FavoriteService");
const FilesDirectoryService_1 = require("./classes/FilesDirectoryService");
const HeadHuntService_1 = require("./classes/HeadHuntService");
const LoyaltyService_1 = require("./classes/LoyaltyService");
const ProfilesService_1 = require("./classes/ProfilesService");
const ReviewsService_1 = require("./classes/ReviewsService");
const SearchService_1 = require("./classes/SearchService");
const SupportService_1 = require("./classes/SupportService");
class ProfiMallAPI {
    /**
    * @param {string} url - baseUrl for api
    * @param {(e: unknown, args?: unknown) => void} errorsHandler? - errors handler for safe methods
    */
    constructor(url, errorsHandler) {
        this._httpClient = new net.HTTPClient(url);
        this.articlesService = new ArticlesService_1.ArticlesService(this._httpClient, errorsHandler);
        this.authService = new AuthService_1.AuthService(this._httpClient, errorsHandler);
        this.businessService = new BusinessService_1.BusinessService(this._httpClient, errorsHandler);
        this.connector1CService = new Connector1CService_1.Connector1CService(this._httpClient, errorsHandler);
        this.deliveryService = new DeliveryService_1.DeliveryService(this._httpClient, errorsHandler);
        this.directoryService = new DirectoryService_1.DirectoryService(this._httpClient, errorsHandler);
        this.favoriteService = new FavoriteService_1.FavoriteService(this._httpClient, errorsHandler);
        this.filesDirectoryService = new FilesDirectoryService_1.FilesDirectoryService(this._httpClient, errorsHandler);
        this.headHuntService = new HeadHuntService_1.HeadHuntService(this._httpClient, errorsHandler);
        this.loyaltyService = new LoyaltyService_1.LoyaltyService(this._httpClient, errorsHandler);
        this.profilesService = new ProfilesService_1.ProfilesService(this._httpClient, errorsHandler);
        this.reviewsService = new ReviewsService_1.ReviewsService(this._httpClient, errorsHandler);
        this.searchService = new SearchService_1.SearchService(this._httpClient, errorsHandler);
        this.supportService = new SupportService_1.SupportService(this._httpClient, errorsHandler);
    }
    getHTTPClient() {
        return this._httpClient;
    }
}
exports.ProfiMallAPI = ProfiMallAPI;
//# sourceMappingURL=ProfiMallAPI.js.map